module.exports = __webpack_public_path__ + "img/incidents-selector.29142813.svg";